import apiService from './apiService.js';

const resource = '/graduation_records';

export default {
    getGraduationRecords() {
        return apiService.get(`${resource}`);
    },
    // data expected to be an array of graduation records
    updateGraduationRecords(data) {
        return apiService.put(`${resource}`, {
            graduation_record_data: data
        });
    },
    createNewGraduationRecord(personId) {
        return apiService.post(`${resource}`, {
            person_id: personId
        });
    },
    createNewVocation(personId, vocation) {
        return apiService.post(`${resource}`, {
            person_id: personId,
            vocation
        });
    },
    getGraduationOptions() {
        return apiService.get('/list_items/graduationOptions');
    },
    getEligibleStudents() {
        return apiService.get(`${resource}/eligibleStudents`);
    },
    getGraduationRecordsIsGenerated() {
        return apiService.get('/graduation-records/is-generated');
    },
    getGradRecordsTable() {
        return apiService.get('/regional-graduation-records');
    }
};
